import DetectDevice from "./DetectDevice";

const DynamicComponent = () => {
  return (
    <div className="text-center p-5">
      <h1 className="text-2xl font-bold">Redirecting...</h1>
      <p className="mt-3">
        <DetectDevice/>
      </p>
    </div>
  );
};

export default DynamicComponent;